import { viewport } from '@/util/viewport';

export default {
  computed: {
    isMobile() {
      return viewport.isCompact;
    },
  },
};
